export default __webpack_public_path__ + "static/media/plant.d2a908cf.png";